export const resolveCatalogErrorMessage = (error: unknown, fallbackMessage: string): string => {
  if (error && typeof error === 'object') {
    const candidate = error as {
      message?: unknown;
      error?: {
        message?: unknown;
        error?: {
          message?: unknown;
        };
      };
    };

    if (typeof candidate.error?.error?.message === 'string' && candidate.error.error.message) {
      return candidate.error.error.message;
    }

    if (typeof candidate.error?.message === 'string' && candidate.error.message) {
      return candidate.error.message;
    }

    if (typeof candidate.message === 'string' && candidate.message) {
      return candidate.message;
    }
  }

  if (error instanceof Error && error.message) {
    return error.message;
  }

  return fallbackMessage;
};
